import { render, staticRenderFns } from "./OrderEditHistory.vue?vue&type=template&id=a27e39c8&"
import script from "./OrderEditHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderEditHistory.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports